<template>
  <div>
    <v-card outlined :class="wo.is_complete ? 'grey lighten-3 mb-4' : 'mb-4'">
      <v-toolbar height='30px' dark :color='woType.color' flat v-if='getDivision(woType.division).division_type !== "S"'>
        <!-- <v-icon>{{woType.icon}}</v-icon> -->
        <v-toolbar-title>
          {{ woType.name }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip label v-if='wo.is_attempted' xSmall color='warning' dark>Attempted</v-chip>
      </v-toolbar>
      <table width='100%'>
        <tr>
          <td>
            <v-card-title class='mt-n3'>
              <v-icon left color='red' v-if='wo.project_is_quickpay'>mdi-timer-outline</v-icon>
              <v-icon left color='error' v-if="wo.priority === 2">mdi-alert</v-icon>
              <v-icon left color='warning' class='ml-n2 mr-0' v-if="wo.priority === 1">mdi-exclamation-thick</v-icon>
              {{ wo.project_name }}
              <span color='error' class='ml-2' v-if="wo.is_attempted">(Attempted)</span>
              <v-icon small class='icon' v-if="wo.is_hose_bib">mdi-water-pump</v-icon>
          <div style="display: flex, flex-direction: row"  v-if="wo.has_charged_hose_bib">
            <v-icon class='icon' style="padding-right: 0, padding-left: 0">mdi-alpha-h</v-icon>
            <v-icon class='icon' style="margin-left: -15px">mdi-alpha-b</v-icon>
          </div>
          <div style="display: flex, flex-direction: row" v-if="wo.has_charged_feature">
            <v-icon class='icon' style="padding-right: 0, padding-left: 0">mdi-alpha-w</v-icon>
            <v-icon class='icon' style="margin-left: -15px">mdi-alpha-f</v-icon>
          </div>
              </v-card-title>
            <v-card-subtitle class='pb-0 grey--text text--darken-2'>
              <v-btn icon small @click='getDirections'>
                <v-icon color='info'>mdi-directions</v-icon>
              </v-btn>
              {{ wo.project_site_address }}
              <span v-if='wo.project_site_city'>, {{ wo.project_site_city }}</span>
            </v-card-subtitle>
          </td>
          <td class='text-right pr-2'>
            <v-btn
              v-if='getDivision(woType.division).division_type === "S"'
              height='50px'
              width='50px'
              @click='showConfirm = true'
              fab
              depressed
              :color="wo.is_complete ? 'success' : 'grey lighten-3'"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              v-else
              @click='openWO'
              height='40px'
              width='50px'
              depressed
              :color="wo.is_complete ? 'success' : 'grey lighten-3'"
            >
              Open
            </v-btn>
          </td>
        </tr>
      </table>
      <v-card-text class='pb-1 pt-0' v-if="wo.project_needs_key">
        <v-icon class='mt-n1 mr-n1' small color='error'>mdi-key-variant</v-icon>
        <span class='error--text ml-2 mb-n1 subtitle-2'>Key required</span>
      </v-card-text>
      <v-card-text v-if='wo.apt_time' class='py-0 error--text font-weight-bold'>
        <v-icon left color='error'>mdi-clock-outline</v-icon>
        <span class='ml-n1'>{{ wo.apt_time | time }}</span>
        <span v-if='wo.apt_end'> - {{ wo.apt_end | time }}</span>
        <span> {{ wo.apt_end ? ' Apt. window' : ' Appointment' }}</span><br>
        <p v-if='wo.apt_notes' class='ml-7 mb-0 font-weight-regular'>{{ wo.apt_notes }}</p>
      </v-card-text>
      <v-card-text class='pb-1 pt-0' v-if="wo.call_mins_ahead > 0">
        <v-icon class='mt-n1 mr-n1' small color='error'>mdi-phone</v-icon>
        <span class='error--text ml-2 mb-n1 subtitle-1'>{{ wo.call_mins_ahead }}</span>
      </v-card-text>
      <v-card-text class='pb-1 pt-0' v-if='wo.project_field_instructions && getDivision(woType.division).division_type === "S"'>
        <span v-html='wo.project_field_instructions' class='info--text font-weight-bold font-italic'></span>
      </v-card-text>

      <v-card-text class='pb-1 pt-0' v-if='wo.instructions && getDivision(woType.division).division_type === "S"'>
        <span v-html='wo.instructions'
          :class="(this.wo.priority === 2) ? 'error--text' : 'warning--text'"
          class='font-weight-bold font-italic'
        ></span>
      </v-card-text>
      
      <v-card-text class='pb-1 pt-0' v-if='wo.problem_description && getDivision(woType.division).division_type === "S"'>
        <span v-html='wo.problem_description'
          class='font-weight-bold font-italic warning--text'
        ></span>
      </v-card-text>
    </v-card>

    <wc-confirm
      :showDialog='showConfirm'
      @cancel='showConfirm = false'
      @confirm='markWOComplete'
    >
      <span v-if='!wo.is_complete'>Are you sure you want to mark this site as complete?</span>
      <span v-else>
        Are you sure you want to UNDO marking this site as complete?
        This will put the WO back onto your list of "To-dos"</span>
      <br>
      <br>
      <strong class='primary--text'>
        {{ wo.project_name }}<br>
        {{ wo.project_site_address }}
      </strong>
    </wc-confirm>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import wosAPI from '@/modules/wos/api/'

export default {
  name: 'wo-card',
  props: {
    wo: {
      required: true
    },
    woType: {
      required: true 
    }
  },
  data: () => ({
    isLoading: false,
    showConfirm: false
  }),
  computed: {
    today () {
      return moment().format('YYYY-MM-DD').toString()
    }
  },
  methods: {
    getDirections () {
      let URL = "https://www.google.com/maps/dir/?api=1&destination=" + this.wo.project_site_address + '+' + this.wo.project_site_city
      window.open(URL, '_blank', )
    },
    getDivision (div) {
      return _.find(this.$store.state.misc.divisions, function(w) { return w.id === div })
    },
    markWOComplete() {
      this.showConfirm = false
      let woCopy = _.cloneDeep(this.wo)
      let newVisit = {
        work_order: this.wo.id,
        created_by: this.$store.state.auth.profile.id,
        notes: ''
      }
      if (woCopy.is_complete) {
        woCopy.is_complete = false
        woCopy.date_completed = null
        newVisit.notes = 'REMOVING completed status'
      } else {
        woCopy.is_complete = true
        woCopy.date_completed = this.today
        newVisit.notes = 'Work order completed'
      }
      wosAPI.updateWO(woCopy)
      wosAPI.createCrewVisitForWO(newVisit)
      this.$emit('woComplete', woCopy)
    },
    openWO () {
      this.$router.push({ name: 'IrrigationFieldDetailOverview', params: { id: this.wo.id } })
    }
  }
}
</script>
